import api from './client';

export const getDevices = async () => {
  const { data } = await api.get('/devices');
  return data;
};

export const renameDevice = async (id, name) => {
  const { data } = await api.patch(`/devices/${id}`, { name });
  return data;
};

export const revokeDevice = async (id) => {
  await api.delete(`/devices/${id}`);
};

export const getSessions = async () => {
  const { data } = await api.get('/sessions');
  return data;
};

export const revokeSession = async (id) => {
  await api.delete(`/sessions/${id}`);
};

export const revokeAllOtherSessions = async () => {
  await api.delete('/sessions');
};

export const getTwoFactorStatus = async () => {
  const { data } = await api.get('/two-factor/status');
  return data;
};

export const beginTwoFactorSetup = async () => {
  const { data } = await api.post('/two-factor/setup/begin');
  return data;
};

export const confirmTwoFactorSetup = async (code) => {
  const { data } = await api.post('/two-factor/setup/confirm', { code });
  return data;
};

export const disableTwoFactor = async () => {
  const { data } = await api.post('/two-factor/disable');
  return data;
};

export const regenerateRecoveryCodes = async () => {
  const { data } = await api.post('/two-factor/recovery-codes/regenerate');
  return data;
};

export const getRecoveryCodes = async () => {
  const { data } = await api.get('/two-factor/recovery-codes');
  return data;
};

export const getAuditEvents = async (page = 1, pageSize = 20) => {
  const offset = (page - 1) * pageSize;
  const { data } = await api.get('/audit/events', { params: { limit: pageSize, offset } });
  return data;
};

export const changeMasterPasswordApi = async ({ currentAuthKey, newAuthKey, newEncryptedVaultKey }) => {
  const { data } = await api.post('/auth/change-password', {
    currentAuthKey,
    newAuthKey,
    newEncryptedVaultKey,
  });
  return data;
};
